export {
  EntityCard
} from '@roc/ui';